import { createActions } from 'redux-actions';

export const {
  // GET REQUESTS
  getEmployee,
  getEmployeeSuccess,
  getEmployeeError,
  getCheckUserByPhoneNumber,
  getCheckUserByPhoneNumberSuccess,
  getCheckUserByPhoneNumberError,
  // POST REQUEST
  createEmployee,
  createEmployeeSuccess,
  createEmployeeError,
  // PUT REQUEST
  updateEmployee,
  updateEmployeeSuccess,
  updateEmployeeError,
  updateEmployeeStatus,
  updateEmployeeStatusSuccess,
  updateEmployeeStatusError,
  // DELETE REQUEST
  //
  createEmployeeClearError,
} = createActions(
  'GET_EMPLOYEE',
  'GET_EMPLOYEE_SUCCESS',
  'GET_EMPLOYEE_ERROR',
  'GET_CHECK_USER_BY_PHONE_NUMBER',
  'GET_CHECK_USER_BY_PHONE_NUMBER_SUCCESS',
  'GET_CHECK_USER_BY_PHONE_NUMBER_ERROR',
  'CREATE_EMPLOYEE',
  'CREATE_EMPLOYEE_SUCCESS',
  'CREATE_EMPLOYEE_ERROR',
  'UPDATE_EMPLOYEE',
  'UPDATE_EMPLOYEE_SUCCESS',
  'UPDATE_EMPLOYEE_ERROR',
  'UPDATE_EMPLOYEE_STATUS',
  'UPDATE_EMPLOYEE_STATUS_SUCCESS',
  'UPDATE_EMPLOYEE_STATUS_ERROR',
  'CREATE_EMPLOYEE_CLEAR_ERROR'
);
